import { IEditModGroupRestaurantPropertiesContext } from './editModGroupRestaurantPropertiesContext';

export enum EditModGroupRestaurantPropertiesActionTypes {
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_DATA_FROM_RESTAURANT = 'SET_DATA_FROM_RESTAURANT',
	TOGGLE_FORCE_DISABLE = 'TOGGLE_FORCE_DISABLE',
	SET_CHILDREN = 'SET_CHILDREN',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
}

interface IRefetchRestPropsData {
	type: EditModGroupRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IEditModGroupRestaurantPropertiesContext['needRefetchRestPropsData'];
	};
}

interface ISetAllData {
	type: EditModGroupRestaurantPropertiesActionTypes.SET_ALL_DATA;
	payload: {
		modGroupId: IEditModGroupRestaurantPropertiesContext['modGroupId'];
		modGroupName: IEditModGroupRestaurantPropertiesContext['modGroupName'];
		customerId: IEditModGroupRestaurantPropertiesContext['customerId'];
		customerName: IEditModGroupRestaurantPropertiesContext['customerName'];
		fetchedRestaurants: IEditModGroupRestaurantPropertiesContext['fetchedRestaurants'];
	};
}

interface ISetIDRestaurant {
	type: EditModGroupRestaurantPropertiesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IEditModGroupRestaurantPropertiesContext['IDSelectedRestaurant'];
		forceDisable: IEditModGroupRestaurantPropertiesContext['forceDisable'];
		isPortionFlow: IEditModGroupRestaurantPropertiesContext['isPortionFlow'];
		parents: IEditModGroupRestaurantPropertiesContext['parents'];
		children: IEditModGroupRestaurantPropertiesContext['children'];
	};
}

interface ISetDataFromRestaurant {
	type: EditModGroupRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT;
	payload: {
		forceDisable: IEditModGroupRestaurantPropertiesContext['forceDisable'];
		isPortionFlow: IEditModGroupRestaurantPropertiesContext['isPortionFlow'];
		parents: IEditModGroupRestaurantPropertiesContext['parents'];
		children: IEditModGroupRestaurantPropertiesContext['children'];
	};
}

interface IToggleForceDisable {
	type: EditModGroupRestaurantPropertiesActionTypes.TOGGLE_FORCE_DISABLE;
}

interface ISetChildren {
	type: EditModGroupRestaurantPropertiesActionTypes.SET_CHILDREN;
	payload: {
		children: IEditModGroupRestaurantPropertiesContext['children'];
	};
}

interface ISetDataForSubmit {
	type: EditModGroupRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditModGroupRestaurantPropertiesContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditModGroupRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditModGroupRestaurantPropertiesContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: EditModGroupRestaurantPropertiesActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IEditModGroupRestaurantPropertiesContext['errorResponseData'];
	};
}

export type TEditModGroupRestaurantPropertiesAction =
	| IRefetchRestPropsData
	| ISetAllData
	| ISetIDRestaurant
	| ISetDataFromRestaurant
	| IToggleForceDisable
	| ISetChildren
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo;
